import addReduxUtil from 'modules/redux/utils/add'
import createReduxUtil from 'modules/redux/utils/create'
import getPathReduxUtil from 'modules/redux/utils/get-path'
import afterCreateReduxHookUtil from 'modules/redux/utils/hooks/after-create'
import { CIDS_DOMAIN } from 'modules/training/modules/cids'
import setUtil from 'utils/set'
import createAssociationsCreateReduxUtil from 'modules/redux/actions/create/create-association'
import { getObjectUtil } from 'packages/src'

export default function createInstanceCreateUtil (stateWrapper, payload) {
  // Get the cid
  const {
    data,
    domainListPath,
    existingInstance,
    domainPath,
    options = {},
    path
  } = payload

  const className = (
    payload.className ||
    existingInstance?.className ||
    data.className ||
    getObjectUtil(data, 'data.className')
  )

  let cidDomain = stateWrapper.state[CIDS_DOMAIN]
  let cid = cidDomain[className]
  if (!cid) {
    cid = 1
  }
  // Create the instance
  let instance = createReduxUtil({
    ...data,
    className,
    cid
  })

  // Create the associations
  // e.g. Workout.workoutSections
  instance = createAssociationsCreateReduxUtil(stateWrapper, {
    instance,
    existingInstance
  })

  // Add the instance do the state
  stateWrapper.state = addReduxUtil({
    state: stateWrapper.state,
    instance,
    existingInstance,
    domainListPath,
    domainPath,
    options,
    path
  })

  const pathToUse = payload.path || getPathReduxUtil(instance, domainPath)
  instance = getObjectUtil(stateWrapper.state, pathToUse)
  // Trigger the after create hook if there is one
  stateWrapper.state = afterCreateReduxHookUtil(instance, stateWrapper.state)
  instance = getObjectUtil(stateWrapper.state, pathToUse)
  // Increment the cid
  if (!existingInstance) {
    cidDomain = {
      ...stateWrapper.state[CIDS_DOMAIN],
      [className]: cid + 1
    }
    stateWrapper.state = setUtil(stateWrapper.state, CIDS_DOMAIN, cidDomain)
  }
  return instance
}
